// import React, { useState, useMemo } from "react";
// import "./Timeline.css";
// import InfoTooltipIcon from "../../../../HtmlElements/InfoTooltipIcon";

// const COLORS = [
//   "#058516",
//   "#47568E",
//   "#B06F0E",
//   "#9B1B30",
//   "#00796B",
//   "#6A1B9A",
// ];

// const Timeline = ({ data = [], filterColumn }) => {
//   const [selectedFilters, setSelectedFilters] = useState([]);

//   // Collect unique filter values and assign colors
//   const filterMap = useMemo(() => {
//     if (!filterColumn) return null;
//     const uniqueValues = [...new Set(data.map((d) => d[filterColumn]))].filter(
//       Boolean
//     );
//     return uniqueValues.reduce((acc, val, i) => {
//       acc[val] = COLORS[i % COLORS.length];
//       return acc;
//     }, {});
//   }, [data, filterColumn]);

//   const toggleFilter = (val) => {
//     setSelectedFilters((prev) =>
//       prev.includes(val) ? prev.filter((f) => f !== val) : [...prev, val]
//     );
//   };

//   const filteredData =
//     selectedFilters.length && filterMap
//       ? data.filter((item) => selectedFilters.includes(item[filterColumn]))
//       : data;

//   return (
//     <div className="timeline-wrapper">
//       {/* Chip Filters */}
//       {filterMap && (
//         <div className="chip-filters">
//           {Object.keys(filterMap).map((val) => (
//             <button
//               key={val}
//               className={`chipt ${
//                 selectedFilters.includes(val) ? "selected" : ""
//               }`}
//               onClick={() => toggleFilter(val)}
//             >
//               {val}
//             </button>
//           ))}
//         </div>
//       )}

//       {/* Timeline */}
//       <div className="timeline-container">
//         <div className="timeline-scrollable">
//           <div className="timeline">
//             {filteredData.map((item, index) => (
//               <div className="timeline-entry" key={index}>
//                 <div className="timeline-marker"></div>
//                 <div className="timeline-date">{item.date}</div>
//                 <div className="timeline-card">
//                   <h4>
//                     {item?.title?.value}
//                     {typeof item?.title === "object" &&
//                       item?.title?.value !== null && (
//                         <InfoTooltipIcon payload={item?.title} />
//                       )}
//                   </h4>

//                   {item.description && (
//                     <p>
//                       {item.description?.value || item.description || "-"}

//                       {typeof item?.description === "object" &&
//                         item?.description?.value !== null && (
//                           <InfoTooltipIcon payload={item?.description} />
//                         )}
//                     </p>
//                   )}
//                   {/* {filterColumn && item[filterColumn] && (
//                     <span
//                       className="category-label"
//                       style={{
//                         color: filterMap[item[filterColumn]],
//                         border: `1px solid ${filterMap[item[filterColumn]]}`,
//                       }}
//                     >
//                       {item[filterColumn]}
//                     </span>
//                   )} */}

//                   {filterColumn?.length > 0 && item[filterColumn] && (
//                     <span
//                       className="category-label"
//                       style={{
//                         color:
//                           filterMap[
//                             typeof item[filterColumn] === "object"
//                               ? item[filterColumn]?.value
//                               : item[filterColumn]
//                           ],
//                         border: `1px solid ${
//                           filterMap[
//                             typeof item[filterColumn] === "object"
//                               ? item[filterColumn]?.value
//                               : item[filterColumn]
//                           ]
//                         }`,
//                       }}
//                     >
//                       {typeof item[filterColumn] === "object"
//                         ? item[filterColumn]?.value
//                         : item[filterColumn]}

//                       {typeof item[filterColumn] === "object" &&
//                         item[filterColumn]?.value !== null && (
//                           <InfoTooltipIcon payload={item[filterColumn]} />
//                         )}
//                     </span>
//                   )}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Timeline;

import React, { useState, useMemo } from "react";
import "./Timeline.css";
import InfoTooltipIcon from "../../../../HtmlElements/InfoTooltipIcon";

const COLORS = [
  "#058516",
  "#47568E",
  "#B06F0E",
  "#9B1B30",
  "#00796B",
  "#6A1B9A",
];

const Timeline = ({ data = [], filterColumn, from = "" }) => {
  const [selectedFilters, setSelectedFilters] = useState([]);

  // helper to extract display value from either a primitive or an object { value: "..." }
  const getFieldValue = (field) => {
    if (field == null) return null;
    return typeof field === "object" ? field.value ?? null : field;
  };

  // helper to detect if a field is an object that can be used as tooltip payload
  const hasTooltipPayload = (field) =>
    field != null && typeof field === "object" && field.value != null;

  // Build color map and sample payload map (for chips) from data[filterColumn]
  const { colorMap, samplePayloadMap } = useMemo(() => {
    if (!filterColumn) return { colorMap: null, samplePayloadMap: {} };

    const values = [];
    const samplePayloads = {};

    data.forEach((d) => {
      const raw = d?.[filterColumn];
      const val = getFieldValue(raw);
      if (val) {
        values.push(val);
        // store a representative object payload for this value if available
        if (hasTooltipPayload(raw) && !samplePayloads[val]) {
          samplePayloads[val] = raw;
        }
      }
    });

    const unique = [...new Set(values)];
    const cmap = unique.reduce((acc, val, i) => {
      acc[val] = COLORS[i % COLORS.length];
      return acc;
    }, {});

    return { colorMap: cmap, samplePayloadMap: samplePayloads };
  }, [data, filterColumn]);

  const toggleFilter = (val) => {
    setSelectedFilters((prev) =>
      prev.includes(val) ? prev.filter((f) => f !== val) : [...prev, val]
    );
  };

  // filter using extracted value
  const filteredData =
    selectedFilters.length && colorMap
      ? data.filter((item) =>
          selectedFilters.includes(getFieldValue(item?.[filterColumn]))
        )
      : data;

  return (
    <div className="timeline-wrapper">
      {/* Chip Filters (derived from filterColumn values) */}
      {colorMap && (
        <div className="chip-filters">
          {Object.keys(colorMap).map((val) => (
            <button
              key={val}
              className={`chipt ${
                selectedFilters.includes(val) ? "selected" : ""
              }`}
              onClick={() => toggleFilter(val)}
              // optionally style chip border/background using colorMap (if desired)
              style={{
                borderColor: colorMap[val],
              }}
            >
              <span className="chipt-label">{val}</span>

              {/* show info icon on the chip if a sample payload (object) exists */}
              {samplePayloadMap[val] && (
                <InfoTooltipIcon payload={samplePayloadMap[val]} from={from} />
              )}
            </button>
          ))}
        </div>
      )}

      {/* Timeline */}
      <div className="timeline-container">
        <div className="timeline-scrollable">
          <div className="timeline">
            {filteredData.map((item, index) => {
              const titleVal = getFieldValue(item?.title);
              const descVal = getFieldValue(item?.description);
              const categoryRaw = item?.[filterColumn];
              const categoryVal = filterColumn
                ? getFieldValue(categoryRaw)
                : null;
              const categoryColor = categoryVal
                ? colorMap?.[categoryVal]
                : null;

              return (
                <div className="timeline-entry" key={index}>
                  <div className="timeline-marker"></div>
                  <div className="timeline-date">{item.date}</div>
                  <div className="timeline-card">
                    <h4>
                      {titleVal ?? "-"}
                      {hasTooltipPayload(item?.title) && (
                        <InfoTooltipIcon payload={item?.title} from={from} />
                      )}
                    </h4>

                    {item.description !== undefined && (
                      <p>
                        {descVal ?? "-"}
                        {hasTooltipPayload(item?.description) && (
                          <InfoTooltipIcon
                            payload={item?.description}
                            from={from}
                          />
                        )}
                      </p>
                    )}

                    {filterColumn && categoryVal && (
                      <span
                        className="category-label"
                        style={{
                          color: categoryColor,
                          border: `1px solid ${categoryColor}`,
                        }}
                      >
                        {categoryVal}
                        {hasTooltipPayload(categoryRaw) && (
                          <InfoTooltipIcon payload={categoryRaw} from={from} />
                        )}
                      </span>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Timeline;
